export default "__VITE_ASSET__CZnH34MY__"